export const vacancyConst =  {
  CHANGE_MARKED_EMOTION: "CHANGE_MARKED_EMOTION",
  ADD_VACANCY: "ADD_VACANCY",
  DELETE_VACANCY: "DELETE_VACANCY",
  CHANGE_VACANCY: "CHANGE_VACANCY",
  UPDATE_VACANCIES: "UPDATE_VACANCIES",
  CHANGE_PUBLICATION_STATE: "CHANGE_PUBLICATION_STATE",
};


// WEBPACK FOOTER //
// src/constants/vacancies.jsx